import { PuzzleWinDialogInjectableInterface } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog-injectable.interface';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';

import { IonGrid, IonRow, IonText } from '@ionic/angular/standalone';

import { ImagePreviewData } from '../image-puzzle-preview/image-puzzle-preview.component';
import { Store } from '@ngxs/store';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { map } from 'rxjs/operators';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { PuzzleTimeRecordState } from '../../store/puzzle-time-record.state';
import { PuzzleTimeRecordModel } from '../../store/puzzle-time-record.model';
import { Subscription } from 'rxjs';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateService } from '@ngx-translate/core';
import { PuzzleWinDialogService } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog.service';
import { TranslateModule } from '@ngx-translate/core';
import { ImagePuzzlePreviewComponent } from 'projects/tools/src/lib/image-puzzle-module/image-puzzle-preview/image-puzzle-preview.component';

@Component({
  selector: 'lib-app-image-puzzle-win-screen',
  templateUrl: './image-puzzle-win-screen.component.html',
  styleUrls: ['./image-puzzle-win-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, IonGrid, IonRow, IonText, TranslateModule, ImagePuzzlePreviewComponent],
})
export class ImagePuzzleWinScreenComponent implements PuzzleWinDialogInjectableInterface, OnDestroy {
  // @ViewChild('previewContainer', { static: true }) previewContainer: ElementRef;

  public data: ImagePreviewData;

  private puzzleGameSubscription: Subscription;
  private timeRecordSubscription: Subscription;
  // private swedishGameSubscription: Subscription;

  public moveCounter: number;
  public duration: string;

  public maxImageWidth: number;

  public copyright: string;

  public translationKey: string;
  // public solutionWord: string;

  constructor(
    private store: Store,
    private framework: PuzzleFrameworkService,
    private translateService: TranslateService,
    private winDialogService: PuzzleWinDialogService
  ) {
    this.copyright = this.framework.puzzleConfig.copyright;

    this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        this.puzzleGameSubscription = this.store
          .select(PuzzleGameState.getByID(puzzleID))
          .subscribe((puzzleGame: PuzzleGameModel) => {
            this.moveCounter = puzzleGame.moveCounter;
          });
        this.timeRecordSubscription = this.store
          .select(PuzzleTimeRecordState.getTimeRecordByID)
          .pipe(map((filterFn) => filterFn(puzzleID)))
          .subscribe((timeRecord: PuzzleTimeRecordModel) => {
            this.duration = timeRecord.timeRecord.timeString;
          });
        // this.swedishGameSubscription = this.store
        //   .select(SwedishGameState.getPuzzleGameByID)
        //   .pipe(map(filterFn => filterFn(puzzleID)))
        //   .subscribe((swedishGame: SwedishPuzzleModel) => {
        //     this.solutionWord = swedishGame.solutionWord;
        //   });
      });

    this.translationKey = this.framework.getTranslationKey();
    this.translateService
      .get(this.translationKey + '.win_dialog.title')
      .toPromise()
      .then((title) => {
        this.winDialogService.setTitle(title);
      });
  }

  setData(data: ImagePreviewData): void {
    this.data = data;
  }

  ngOnDestroy(): void {
    this.puzzleGameSubscription.unsubscribe();
    this.timeRecordSubscription.unsubscribe();
  }
}
